import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ExternalLink, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/admin", label: "Dashboard", testid: "admin-nav-facts" },
  { to: "/admin/events", label: "Events", testid: "admin-nav-events" },
  { to: "/admin/observances", label: "Observances", testid: "admin-nav-observances" },
  { to: "/admin/number-ones", label: "Number Ones", testid: "admin-nav-number-ones" },
  { to: "/admin/halloffame", label: "Hall of Fame", testid: "admin-nav-halloffame" },
  { to: "/admin/subscribers", label: "Subscribers", testid: "admin-nav-subscribers" },
  { to: "/admin/tools", label: "Tools", testid: "admin-nav-tools" },
];

export const AdminHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/85 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/seal-oddlytrue-red-wax.png" alt="OddlyTrue" className="w-9 h-9 object-contain" />
            <span className="text-xl font-bold text-ink">Oddly<span className="text-gold">True</span></span>
            <span className="ml-2 font-mono text-xs uppercase tracking-widest text-ink-muted hidden sm:inline">/ admin</span>
          </Link>
          <nav className="flex items-center gap-1">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={l.testid} className={`px-3 py-1.5 rounded-full font-mono text-xs transition-colors ${pathname === l.to ? "bg-ink text-white" : "text-ink-muted hover:text-gold"}`}>
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-3">
          <Link to="/" target="_blank" className="hidden sm:inline-flex items-center gap-1.5 font-mono text-xs text-ink-muted hover:text-gold">
            View site <ExternalLink className="w-3.5 h-3.5" />
          </Link>
          <span className="font-mono text-xs text-ink-muted hidden md:inline" data-testid="admin-user-email">{user?.email}</span>
          <button data-testid="admin-logout" onClick={doLogout} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full border border-slate-300 text-ink-muted hover:border-gold hover:text-gold font-mono text-xs transition-colors">
            <LogOut className="w-3.5 h-3.5" /> Logout
          </button>
        </div>
      </div>
    </header>
  );
};
